// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessView_container__C8_6h","title":"SuccessView_title__8Q_9a","footer":"SuccessView_footer__8Hpv_","small-letter":"SuccessView_small-letter__Ndfaz"};